@if (!isError()) {
    <div class="form-group well well-sm" [class.has-error]="!isLoading() && this.bookForm().invalid()">
        <label>
            {{ "address_book" | translate }}
        </label>

        @if (isLoading()) {
            <div class="block-loading">
                <select class="form-control disabled" disabled></select>
            </div>
        } @else {
            <select class="form-control" [formField]="bookForm">
                <option disabled value="" [selected]="bookForm().value() === ''">
                    {{ "choose_address_book" | translate }}
                </option>
                @for (item of data(); track item.id) {
                    <!-- [selected] re-applies the field value when options render after it
                         was written (the books query resolves async) — the formField
                         directive only syncs select.value on field changes. -->
                    <option [value]="item.id" [selected]="isSelected(item.id)">
                        {{ item.address_book_name }}
                    </option>
                }
            </select>
            @if (this.bookForm().invalid()) {
                <span class="help-block small">{{ "control_errors_required" | translate }}</span>
            } @else if (showContactHint()) {
                <span class="help-block small contacts-hint">
                    <span class="sp-icon icon-info-bold color-light"> </span>
                    {{ "added_to_mailing_list_contact_hint" | translate }}<br /><a
                        [href]="'added_to_mailing_list_contact_hint_link' | translate"
                        target="_blank"
                        >{{ "added_to_mailing_list_contact_hint_link_text" | translate }}
                        <span class="sp-icon icon-outgoing small-xs color-light"> </span
                    ></a>
                </span>
            }
        }
    </div>
} @else {
    <div class="alert alert-danger">
        {{ "unknown_error" | translate }}
    </div>
}
